import { Component, OnInit, Input } from '@angular/core';
import { cloneDeep } from 'lodash';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { AeroDataChannel } from 'src/app/models/AeroDataChannel';
import { FligthInspectionConfigAbstract } from 'src/app/models/FligthInspectionConfigAbstract';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { ColorInterval, FlightInspectionStyleComponent } from '../flight-inspection-style/flight-inspection-style.component';
import { HttpClient } from '@angular/common/http';
import { WietzeToolConfig } from 'src/app/models/FligthInspectionConfig';
import { PointsService } from 'src/app/services/points.service';
import { NavaidModel } from 'src/app/models/navaid';
import { Feature } from 'ol';
import { Channel } from '../configure-flight-inpection-format/configure-flight-inpection-format.component';

@Component({
  selector: 'app-configure-processing-tool-format',
  templateUrl: './configure-processing-tool-format.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class ConfigureProcessingToolFormatComponent implements OnInit {

  activeImportConfig:boolean = true;
  activeInputData:boolean = false;
  activeOutputData: boolean = false;
  activeSot:boolean = false;
  activeflags :boolean = false;
  activeChannel : boolean[] = [false, false, false, false];
  isValidCurrentChannel: boolean = null;

  navaid: NavaidModel;

  @Input() importConfig : any;
  @Input() defaultConfig: any;
  @Input() fieldConfigurationTable: any = {};
  @Input() fileFormat: string;
  @Input() selectedChannelIndex: number | null = null;
  navaidOptions : String[] = [];

  onClose: Subject<boolean>;

  

  constructor(public bsModalRef : BsModalRef,
    public popupService: BsModalService,
    public http: HttpClient,
    public endpointService: EndpointsService,
    private messageModal: ModalControlService,
    private pointsService: PointsService) { }

  ngOnInit(): void {
    this.onClose = new Subject();
  }

  selectChannel(index: number): void {
    this.selectedChannelIndex = index;

    // Update `isUsed` based on selection
    this.importConfig.channels.forEach((channel, i) => {
      channel.isUsed = (i === index);
    });
  }

  setCurrentChannel(channel: AeroDataChannel){
    for (const channelIte of this.importConfig.channels){
      channelIte.isUsed = false;
    }
    channel.isUsed = true;
    this.importConfig.currentChannel = channel.navaidId;
    this.validateCurrentChannel();
  }

  getNavaidStringOptions(){
    if(this.navaidOptions.length == 0){
      this.pointsService.getAllNavaidsFeaturesFromLayers()
      .forEach((navaid:Feature) =>{
        this.navaidOptions.push(navaid.get('navaidid')+"-" +navaid.get('navaidtype') + "-"+ navaid.get('icaocc'))
      })
    }
    return this.navaidOptions;
  }

  validateCurrentChannel(navaidId?: string){
    navaidId != null? this.importConfig.currentChannel = navaidId: false;
		const splits : string[]= this.importConfig.currentChannel.split("-");
    this.navaid = this.pointsService.getRNAVNavaidFromLayersByOldUniqueID(splits[0],splits[2], splits[1]);
    if (this.navaid != null){
      this.isValidCurrentChannel = true;
    } else {
      this.isValidCurrentChannel = false;
    }
  }

  validChannel(channel){
    return !channel.isUsed || this.navaidOptions.find((option) => option == channel.navaidId) != null
  }

  validChannels(){
    for(let channel of this.importConfig.channels){
      if(channel.channelName != "SIO-VOR_DME-LS" &&
      channel.channelName != "VIT-DME-LB" &&
      channel.channelName != "TACAN1"&&
      channel.channelName != "TACAN2"&&
      this.navaidOptions.find((option) => option == channel.channelName) == null)
        return false;
    }
    return true;
  }

  validNavaid(navaid:string){
    return navaid == "TIS-VOR_DME-LF" ||this.navaidOptions.find((option) => option == navaid) != null;
  }

  getChannel(index: number): AeroDataChannel{
    return this.importConfig.channels.find(channel => channel.name == (index + 1).toString());
  }


  close(){
    this.bsModalRef.hide();
  }

  deactiveOtherChannels(channelToNotDeactivate: number){
    for (let i = 0; i<this.activeChannel.length; i++){
      i!=channelToNotDeactivate? this.activeChannel[i] = false: this.activeChannel[i] = true;
    }
  }
  activateImportConfig(){
    this.activeImportConfig = true;
    this.activeInputData = false;
    this.activeOutputData = false;
    this.activeSot = false;
    this.activeflags = false;
    this.deactiveOtherChannels(-1); // deactivate all channels
  }
  activateInputData(){
    this.activeOutputData = false;
    this.activeImportConfig = false;
    this.activeInputData = true;
    this.activeSot = false;
    this.activeflags = false;
    this.deactiveOtherChannels(-1); // deactivate all channels
  }
  activateOutputData(){
    this.activeOutputData = true;
    this.activeImportConfig = false;
    this.activeInputData = false;
    this.activeSot = false;
    this.activeflags = false;
    this.deactiveOtherChannels(-1); // deactivate all channels
  }
  activateSot(){
    this.activeOutputData = false;
    this.activeImportConfig = false;
    this.activeInputData = false;
    this.activeSot = true;
    this.activeflags = false;
    this.deactiveOtherChannels(-1); // deactivate all channels
  }
  activateFlags(){
    this.activeOutputData = false;
    this.activeImportConfig = false;
    this.activeInputData = false;
    this.activeSot = false;
    this.activeflags = true;
    this.deactiveOtherChannels(-1); // deactivate all channels
  }
  activateChannel1(){
    this.activeOutputData = false;
    this.activeImportConfig = false;
    this.activeInputData = false;
    this.activeSot = false;
    this.activeflags = false;
    this.deactiveOtherChannels(0); // deactivate all channels
  }
  activateChannel2(){
    this.activeOutputData = false;
    this.activeImportConfig = false;
    this.activeInputData = false;
    this.activeSot = false;
    this.activeflags = false;
    this.deactiveOtherChannels(1);
  }
  activateChannel3(){
    this.activeOutputData = false;
    this.activeImportConfig = false;
    this.activeInputData = false;
    this.activeSot = false;
    this.activeflags = false;
    this.deactiveOtherChannels(2);
  }
  activateChannel4(){
    this.activeOutputData = false;
    this.activeImportConfig = false;
    this.activeInputData = false;
    this.activeSot = false;
    this.activeflags = false;
    this.deactiveOtherChannels(3);
  }
  openStyleOfField(i:number, isInputData: boolean){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    let config;
    isInputData? config = this.importConfig.fileFormatElements[i]: config = this.defaultConfig.fileFormatElements[i];
    bsModalRef.content.title = config.name + ' - '+config.units;
    bsModalRef.content.colorIntervals = config.style? cloneDeep(config.style) : [];
    bsModalRef.content.validIntervals = new Array(config.style.length).fill(true);
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      config.style = colorIntervals;
    })
  }
  editFlagStyle(i:number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    bsModalRef.content.title = this.importConfig.flags[i].flag ;
    bsModalRef.content.colorIntervals = this.importConfig.flags[i].style? cloneDeep(this.importConfig.flags[i].style) : [];
    bsModalRef.content.validIntervals = new Array(this.importConfig.flags[i].style.length).fill(true);
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      this.importConfig.flags[i].style = colorIntervals;
    })
  }
  editSoTStyle(i:number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    bsModalRef.content.title = this.importConfig.sots[i].name ;
    bsModalRef.content.colorIntervals = this.importConfig.sots[i].style? cloneDeep(this.importConfig.sots[i].style) : [];
    bsModalRef.content.validIntervals = new Array(this.importConfig.sots[i].style.length).fill(true);
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      this.importConfig.sots[i].style = colorIntervals;
    })
  }
  editChannelStyle(channelIndex:number, columnIndex: number){
    const bsModalRef: BsModalRef = this.popupService.show(FlightInspectionStyleComponent);
    const channel = this.getChannel(channelIndex);
    bsModalRef.content.title = channel.columns[columnIndex].name + ' - ' + channel.columns[columnIndex].units;
    bsModalRef.content.colorIntervals = channel.columns[columnIndex].style? cloneDeep(channel.columns[columnIndex].style) : [];
    bsModalRef.content.validIntervals = new Array(channel.columns[columnIndex].style.length).fill(true);
    bsModalRef.content.result.subscribe((colorIntervals: ColorInterval[])=>{
      channel.columns[columnIndex].style = colorIntervals;
    })
  }
  restoreDefault(defaultConfig?: any){
    let toSendFormat: string;
    defaultConfig == null? toSendFormat = WietzeToolConfig.DEFAULT_FORMAT: toSendFormat = this.fileFormat;
    this.http
      .get<any>(
        this.endpointService.endpointGetFlightInspectionConfig + '/' + toSendFormat,
        this.endpointService.httpOptions
      ).subscribe((config:any)=>{
          if (config == null){
            this.messageModal.showMesssageModal(
              'Processing Tool',
              'There was an error fetching the prefined configuration.'
            );
            return;
          }
          if (defaultConfig == null){
            // assign fetched config to default config and fetch the other config
            this.restoreDefault(config);
          } else {
            this.importConfig = config;
            this.defaultConfig = defaultConfig;
            this.selectedChannelIndex = 0;
          }
        },
      () => {
        this.messageModal.showMesssageModal(
        'Processing Tool',
        'There was an error fetching the prefined configuration.'
      )}
    );
  }
  ok(){
    if (this.fileFormat == "Aerodata"){
      for (const channel of this.importConfig.channels){
        channel.isUsed? this.setCurrentChannel(channel): false;
      }
    }
    this.validateCurrentChannel();
    if (this.isValidCurrentChannel){
      this.onClose.next([this.importConfig, this.defaultConfig, this.navaid as any, this.selectedChannelIndex] as any);
      this.bsModalRef.hide();
    } else {
      this.messageModal.showMesssageModal(
        'Processing Tool',
        `No NavAid found with ${this.importConfig.currentChannel} ID`
      )
    }

  }
}

